export default "__VITE_ASSET__zfJefEZr__"